import React from "react";
import AppointmentsDoctor from "../../../appointments/pages/AppointmentsDoctor/AppointmentsDoctor";
import AppLayoutAssistant from "../../../navigation/Layout/LayoutAssistant";
import useAssistantDoctorId from "../../hooks/useAssistantDoctorId";

export default function AssistantAppointmentsPage() {
  const doctorId = useAssistantDoctorId();

  return (
    <AppointmentsDoctor
      LayoutComponent={AppLayoutAssistant}
      disableRemote={!doctorId}
      medecinIdOverride={doctorId}
    />
  );
}
